import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { I18nProvider } from './i18n';
import { ThemeProvider } from './theme/ThemeProvider';
import App from './App';
import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root was not found in index.html.');
}

/*
 * Provider order matters:
 *   ThemeProvider → sets <html class="dark"> from the stored preference
 *   I18nProvider  → sets <html lang> and <html dir> (RTL for Arabic)
 *   AuthProvider  → resolves the session from the API
 */
createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <I18nProvider>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </I18nProvider>
    </ThemeProvider>
  </StrictMode>,
);
